import { ChangeDetectionStrategy, Component, AfterViewInit, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';

import { ClarityModule } from '@clr/angular';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-viewauftragdialog',
  templateUrl: './viewauftragdialog.component.html',
  styleUrls: ['./viewauftragdialog.component.scss'],
  imports: [ClarityModule, MrTranslatePipe],
})
export class ViewauftragdialogComponent implements AfterViewInit {
  private domsanitizer = inject(DomSanitizer);
  private spinner = inject(SpinnerService);
  private mrTranslate = inject(MrTranslatePipe);

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public filename: string = 'Auftrag';
  titel: string = 'Auftrag anzeigen';
  blobdata: any;

  set data(dataIn: any) {
    this.titel = this.mrTranslate.transform('Auftrag anzeigen');
    this.filename = this.mrTranslate.transform('Auftrag');

    if (dataIn.auftragsnr) {
      this.filename = this.mrTranslate.transform('Auftrag') + ' ' + dataIn.auftragsnr;
    }
    this.blobdata = dataIn.data;

    if (dataIn.data.titel) {
      this.titel = dataIn.data.titel;
      this.filename = dataIn.data.file;
      this.blobdata = dataIn.data.data;
    }
    if (dataIn.titel) this.titel = dataIn.titel;

    let url = this.domsanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.blobdata));
    this.pdf_url = url;
    this.spinner.disable();
  }

  pdf_url: SafeUrl;

  public close() {
    this.closedialog.next(true);
  }

  ngAfterViewInit() {}
}
